import { t } from '@lingui/core/macro';
import { isPresent } from '@luminovo/commons';
import React, { useState } from 'react';

import { Tooltip, TooltipProps } from '../Tooltip';

export const CopyToClipboardTooltip: React.FunctionComponent<{
    value: string | undefined;
    variant?: TooltipProps['variant'];
    /** What the tooltip says before the copy; "Copy to Clipboard" by default. */
    title?: string;
    children: TooltipProps['children'];
}> = ({ value, variant, title: idleTitle, children }) => {
    const initialState = isPresent(value) ? 'idle' : 'disabled';
    const [state, setState] = useState<'idle' | 'copied' | 'failed' | 'disabled'>(initialState);

    const handleCopyClick = async (e: React.MouseEvent) => {
        if (!isPresent(value)) {
            return;
        }
        // The click copies, and nothing else: not a table row's click, and not a link it sits in.
        e.stopPropagation();
        e.preventDefault();

        try {
            await navigator.clipboard.writeText(value);
            setState('copied');
        } catch {
            setState('failed');
        }
    };

    const title = {
        idle: idleTitle ?? t`Copy to Clipboard`,
        copied: t`Copied`,
        failed: t`Failed to Copy`,
        disabled: '',
    };

    return (
        <Tooltip
            variant={variant}
            title={title[state]}
            onClick={handleCopyClick}
            onClose={() => setState(initialState)}
            // "Copy to clipboard" describes the action; the child keeps its own name.
            describeChild
        >
            {children}
        </Tooltip>
    );
};
